import { DeleteOutlined, PlusOutlined } from '@ant-design/icons';
import { useFieldArrayOf } from '@framework/form/form/relations/useFieldsArrayOf.ts';
import { RichTextInput } from '@framework/form/inputs/rich-text/RichTextInput.tsx';
import { FormItem } from '@framework/form/item/FormItem.tsx';
import { FlexRow } from '@framework/ui/components/row/FlexRow.tsx';
import { RowElement } from '@framework/ui/components/row/RowElement.tsx';
import { Button, Card, Popconfirm, Space } from 'antd';
import clx from 'classnames';
import styled from 'styled-components';
import { BooleanConditionEditorInput } from '../../../../inputs/expressions-editor/conditions/BooleanConditionEditorInput.tsx';
import { RuleType } from '../../IRule.ts';
import { CustomWarningRuleTypeSelect } from './CustomWarningRuleTypeSelect.tsx';
import {
  CustomWarningRuleType,
  type ICustomWarningRule,
} from './ICustomWarningRule.ts';

const StyledCustomWarningCard = styled(Card)`
  &.ant-card-bordered {
    border-color: ${({ theme }) => theme.colorBorder};
  }
  margin-bottom: 0;
  margin-top: -1px;
  border-radius: 0;
  &:first-child {
    margin-top: 0;
    border-top-right-radius: ${({ theme }) => theme.borderRadius}px;
    border-top-left-radius: ${({ theme }) => theme.borderRadius}px;
  }
  &:last-child {
    border-bottom-right-radius: ${({ theme }) => theme.borderRadius}px;
    /* border-bottom-left-radius: 0; */
  }
`;
const StyledAddButton = styled(Button)`
  &:not(.first-button) {
    border-top-left-radius: 0;
    border-top-right-radius: 0;
    margin-top: -1px;
  }
`;

const fieldName = `rules.${RuleType.CustomWarnings}.rules`;

export interface ICustomWarningsRuleComponentProps {}

export function CustomWarningsRuleComponent(
  props: ICustomWarningsRuleComponentProps,
) {
  const {
    fields: warnings,
    append,
    remove,
  } = useFieldArrayOf<ICustomWarningRule>({ name: fieldName });
  // style={{ marginBottom: '6px' }}
  return (
    <>
      <div>
        {warnings.map((warning, index) => (
          <StyledCustomWarningCard size="small" key={warning.id}>
            <FormItem
              name={`${fieldName}.${index}.message`}
              label="Messaggio"
              layout={{ removeHelpMargin: true }}
            >
              <RowElement style={{ marginBottom: '6px' }}>
                <RichTextInput name={`${fieldName}.${index}.message`} />
              </RowElement>
            </FormItem>

            <FlexRow
              gutter={8}
              align="flex-start"
              right={
                <>
                  <Popconfirm
                    placement="topRight"
                    title="Vuoi eliminare questo accertamento personalizzato?"
                    okText={
                      <span>
                        <DeleteOutlined /> Elimina
                      </span>
                    }
                    description="Verranno eliminate anche le regole associate."
                    okButtonProps={{
                      danger: true,
                      type: 'primary',
                    }}
                    onConfirm={() => {
                      remove(index);
                    }}
                  >
                    <Button size="middle" danger icon={<DeleteOutlined />} />
                  </Popconfirm>
                </>
              }
            >
              <FormItem
                name={[
                  `${fieldName}.${index}.type`,
                  `${fieldName}.${index}.condition`,
                ]}
                label=""
                layout={{ removeHelpMargin: true, removeLabelSpace: true }}
              >
                <Space align="baseline">
                  <CustomWarningRuleTypeSelect
                    size="middle"
                    name={`${fieldName}.${index}.type`}
                    style={{ minWidth: '200px' }}
                  />
                  <BooleanConditionEditorInput
                    resetToFalse
                    label="Mostra"
                    name={`${fieldName}.${index}.condition`}
                  />
                </Space>
              </FormItem>
            </FlexRow>
          </StyledCustomWarningCard>
        ))}
      </div>
      <div>
        <StyledAddButton
          className={clx({ 'first-button': warnings.length === 0 })}
          size={warnings.length === 0 ? 'large' : 'middle'}
          block={warnings.length === 0}
          icon={<PlusOutlined aria-hidden="true" />}
          onClick={() =>
            append({
              type: CustomWarningRuleType.Error,
              condition: { type: 'static', value: false },
              message: '',
            })
          }
        >
          Aggiungi Accertamento
        </StyledAddButton>
      </div>
    </>
  );
}
